<template>
    <div>
        <room-rent-list :channelType="channelType" />
    </div>
</template>

<script>
import RoomRentList from './room-rent-list.vue'

export default {
    components: {
        RoomRentList,
    },
    data() {
        return {
            channelType: 2, //找房
        }
    },
}
</script>

<style lang="less" scoped></style>
